import { n as o } from "./Logger-CmiOOsKC.js";
import { Mesh as m } from "@babylonjs/core/Meshes/mesh.js";
import { Color3 as l } from "@babylonjs/core/Maths/math.color.js";
import { Material as r } from "@babylonjs/core/Materials/material.js";
import { VertexData as p } from "@babylonjs/core/Meshes/mesh.vertexData.js";
import { PBRMaterial as u } from "@babylonjs/core/Materials/PBR/pbrMaterial.js";
var a = "__textBody", n = /* @__PURE__ */ new Map();
function c(t) {
  let e = n.get(t);
  return e || (e = fetch(t).then(async (s) => {
    if (!s.ok) throw new Error(`HTTP ${s.status}`);
    return await s.json();
  }).catch((s) => (o.warn(`[Text] glyph outlines failed to load (${String(s)}): ${t}`), n.delete(t), null)), n.set(t, e)), e;
}
function d(t, e, s) {
  const i = new u(t, e);
  return i.sideOrientation = r.CounterClockWiseSideOrientation, i.metallic = 0, i.roughness = 0.6, h(i, s), i;
}
function h(t, e) {
  t.albedoColor = new l(e.r, e.g, e.b).toLinearSpace(), t.alpha = e.a, t.transparencyMode = e.a < 1 ? r.MATERIAL_ALPHABLEND : r.MATERIAL_OPAQUE;
}
var M = class {
  _mesh = null;
  _material = null;
  _geometry = null;
  _color = null;
  _parent = null;
  _generation = 0;
  _pending = Promise.resolve();
  constructor(t, e) {
    this._scene = t, this._name = e;
  }
  update(t) {
    const e = ++this._generation;
    if (!t)
      return this._apply(null), this._pending = Promise.resolve(), Promise.resolve(!0);
    const s = Promise.all([c(t.outlineUrl), import("./textBodyGeometry-DBemYZjj.js")]).then(([i, { buildTextBodyGeometry: _ }]) => (e === this._generation && this._apply(i ? _(i, t.glyphs, t.frame) : null), i !== null)).catch((i) => (o.warn(`[Text] "${this._name}" body failed to build, drawing flat: ${String(i)}`), e === this._generation && this._apply(null), !1));
    return this._pending = s.then(() => {
    }), s;
  }
  setColor(t) {
    this._color = t.clone(), this._material && h(this._material, this._color);
  }
  setParent(t) {
    this._parent = t, this._mesh && (this._mesh.parent = t);
  }
  async built() {
    let t;
    do
      t = this._pending, await t;
    while (t !== this._pending);
    return this._geometry && this._color ? {
      geometry: this._geometry,
      color: this._color.clone()
    } : null;
  }
  dispose() {
    this._generation++, this._apply(null);
  }
  _apply(t) {
    if (this._geometry = t, !t) {
      this._mesh?.dispose(!1, !0), this._mesh = null, this._material = null;
      return;
    }
    (!this._mesh || this._mesh.isDisposed()) && (this._mesh = new m(`${this._name}${a}`, this._scene), this._mesh.isPickable = !1, this._material = d(`${this._name}${a}`, this._scene, this._color ?? new l(1, 1, 1).toColor4()), this._mesh.material = this._material);
    const e = new p();
    e.positions = t.positions, e.normals = t.normals, e.indices = t.indices, e.applyToMesh(this._mesh, !0), this._mesh.parent = this._parent;
  }
};
export {
  M as n,
  d as r,
  a as t
};

//# sourceMappingURL=textBody-DYKq_GsW.js.map